<template>
  <div class="knowlitem-space">
    <div>
      <know-banner></know-banner>
    </div>
    <div class="knowledge-news">
      <el-row>
        <el-col :span="18">
          <div class="know-news-left">
            <h2 class="know_item_title">博士大讲堂</h2>
            <div class="doc-module-item" v-for="(item,index) in doctorNews" :key="index">
              <div class="hr-type">
                <el-divider></el-divider>
              </div>
              <div class="doc-module-context">
                <el-row>
                  <el-col :span="6">
                    <div class="doc-module-img" @click="seeDocInfo(item.newsId)">
                      <img :src="item.newsMainImg" width="220" height="155" alt="">
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div class="doc-module-text">
                      <h3 class="highLight" @click="seeDocInfo(item.newsId)">{{item.newsTitle}}</h3>
                      <el-row>
                        <el-col :span='6'><span>时间：{{item.newsDate}}</span></el-col>
                        <el-col :span='8'><span>作者：{{item.newsCreateUserName}}</span></el-col>
                      </el-row>
                      <div>{{item.newsSummary}}</div>
                      <!-- <el-button type="text" class="know_module_more" @click="seeDocInfo(item.newsId)">更多<i class="el-icon-arrow-right el-icon--right"></i></el-button> -->
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="news_page">
              <el-pagination :page-size="pageSize" layout="prev, pager, next" :total="totalPage" @current-change="turnPage" background class="pager_style">
              </el-pagination>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <top-news v-bind:newsType="newsType"></top-news>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import knowBanner from './knowBanner';
import topNews from './topNews';
import { sysNewsData } from '@/api/frontApi/common';
export default {
  data() {
    return {
      rankList: [],
      doctorNews: [],
      newsType: 9,
      keyWord: '',
      topTenList: [],
      isList: true,
      pageNo: 1,
      pageSize: 10,
      totalPage: 0
    };
  },
  components: {
    knowBanner,
    topNews
  },
  created() {
    this.initDoctorMData();
  },
  methods: {
    initDoctorMData() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        newsType: this.newsType
      };
      sysNewsData(params).then(res => {
        this.doctorNews = res.data.list;
        this.totalPage = res.data.totalPage;
      });
    },
    seeDocInfo(textId) {
      this.$router.push({
        name: 'knowInfo',
        params: { knowledgeId: textId }
      });
    },
    turnPage(val) {
      this.pageNo = val;
      this.initDoctorMData();
    }
  }
};
</script>
<style scoped>
.hr-type {
  width: 93%;
}
.doc-module-context {
  width: 100%;
  overflow: hidden;
}
.doc-module-text {
  cursor: pointer;
}
.doc-module-img {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/knowledge/doctorSpace.vue